/**
 * Health alerts: a small banner-feed the backend fills whenever something needs a human
 * (mailbox unreachable, a carrier API failing, disk nearly full, ...). Polled rather than
 * pushed, since a stale-by-a-minute warning is fine for something this low-frequency.
 */

import { useQuery } from '@tanstack/react-query'

import { request } from './client'

export type HealthAlertSeverity = 'error' | 'warning'

export interface HealthAlert {
  key: string
  severity: HealthAlertSeverity
  title: string
  detail: string
  since: string | null
}

export interface HealthAlerts {
  contact: string | null
  checked_at: string
  alerts: HealthAlert[]
}

export function useHealthAlerts() {
  return useQuery({
    queryKey: ['health', 'alerts'],
    queryFn: () => request<HealthAlerts>('/health/alerts'),
    // A fault should surface within a minute of appearing, but does not need to be
    // real-time -- and refetching on focus catches the case someone had the tab open
    // through an outage that has since started.
    refetchInterval: 60_000,
    refetchOnWindowFocus: true,
    staleTime: 30_000,
    retry: false,
  })
}
